var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"offerTableView"},[_c('h4',[_vm._v(_vm._s(_vm.$t('residences.view.availabilities')))]),_c('accomodation-table',{attrs:{"residence":_vm.selectedResidence}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }